import React from 'react';
import useSyiUrls from '../hooks/use-syi-urls';
import { useHistory } from 'react-router-dom';

const createNavigator = history => url => history.push(url);

const getDraftIdFromUrl = urls => () => {
    const path = document.location.pathname;
    const draftPath = urls.draft('');

    if (path.startsWith(draftPath)) {
        return path.substring(draftPath.length);
    }

    // Return undefined to match exactly what a draftId is before being set.
    return undefined;
};

const withUrls = Component => {
    const ComposedComponent = ({ ...props }) => {
        const history = useHistory();
        const urls = useSyiUrls();
        return (
            <Component
                {...props}
                urls={urls}
                navigate={createNavigator(history)}
                getDraftIdFromUrl={getDraftIdFromUrl(urls)}
            />
        );
    };
    return ComposedComponent;
};

export default withUrls;
